import { useMatches } from '@tanstack/react-router';

import { useRole } from '../hooks/useRole';

// Mapping of category routes to their aliases.
const ACTIVE_PATH_ALIASES = {
    '/ports': '/port',
    '/orders': ['/order', '/offer'],
    '/offers': ['/offer', '/requests-for-quotes'],
    '/vessels': '/vessel',
    '/settings': ['/members', '/customer-groups', '/supplier-groups'],
};

const ACTIVE_ADMIN_PATH_ALIASES = {
    '/ports': '/port',
    '/orders': '/order',
    '/offers': '/offer',
    '/vessels': '/vessel',
    '/customers': '/customer',
    '/settings': '/members',
};

// Check if the resolved link is an alias.
const isAlias = (to: string): to is keyof typeof ACTIVE_PATH_ALIASES => to in ACTIVE_PATH_ALIASES;
const isAdminAlias = (to: string): to is keyof typeof ACTIVE_ADMIN_PATH_ALIASES => to in ACTIVE_ADMIN_PATH_ALIASES;

// This is a temporary solution to highlight the active category in the sidebar.
export const useRouteInCategory = (to: string) => {
    const role = useRole();
    const matches = useMatches();
    const pathname = matches.at(-1)?.pathname;

    const isRouteInCategory = () => {
        if (!pathname) {
            return false;
        }

        // Make offer routes to order subroutes for customers.
        if (role.isCustomer() && matches.some((match) => match.routeId.startsWith('/_app/offer'))) {
            return to.includes('/orders');
        }
        if (role.isCustomer() && matches.some((match) => match.routeId.startsWith('/_app/offer'))) {
            return to.includes('/orders');
        }

        // Handle subroutes with different paths
        if (isAlias(to) || isAdminAlias(to)) {
            const aliases = role.isSuperAdmin() ? ACTIVE_ADMIN_PATH_ALIASES[to] : ACTIVE_PATH_ALIASES[to];

            // Handle aliases with more than one subroute
            if (Array.isArray(aliases)) {
                return aliases.some((alias) => pathname.includes(alias));
            }

            return pathname.includes(aliases);
        }

        return pathname === to || pathname.startsWith(`${to}/`);
    };

    return isRouteInCategory();
};
